module.exports = __webpack_public_path__ + "static/media/Icon_menu_search.da5d941f.svg";